'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VisibilityLocationSelector;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseRadioButton = require('@bibliocommons/base-radio-button');

var _baseRadioButton2 = _interopRequireDefault(_baseRadioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VisibilityLocationSelector(_ref) {
  var listLocales = _ref.listLocales,
      handleChange = _ref.handleChange,
      location = _ref.location;

  return _react2.default.createElement(
    'div',
    { className: 'cp-visibility-location-selector' },
    listLocales.map(function (label, value) {
      return _react2.default.createElement(_baseRadioButton2.default, {
        id: 'list-visibility-location-' + value,
        name: 'list-visibility-location',
        key: 'list-visibility-location-' + value,
        value: value,
        label: label,
        checked: location === value,
        handleChange: handleChange });
    }).toIndexedSeq().toJS()
  );
}

VisibilityLocationSelector.propTypes = {
  listLocales: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string).isRequired,
  handleChange: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/visibility-location-selector/components/VisibilityLocationSelector.component.js
// module id = 1352
// module chunks = 0